// Converted to lazy loading
const salesChequesIndex = () => import('@/pages/cheques/salesCheques/index.vue')
const salesChequesForm = () => import('@/pages/cheques/salesCheques/form.vue')
const salesChequesShow = () => import('@/pages/cheques/salesCheques/show.vue')

const purchaseChequesIndex = () => import('@/pages/cheques/purchaseCheques/index.vue')
const purchaseChequesForm = () => import('@/pages/cheques/purchaseCheques/form.vue')
const purchaseChequesShow = () => import('@/pages/cheques/purchaseCheques/show.vue')

const routes = [
  {
    path: 'salesCheques',
    name: 'salesCheques',
    component: salesChequesIndex
  },
  {
    path: 'salesCheques/create',
    name: 'salesChequesCreate',
    component: salesChequesForm
  },
  {
    path: 'salesCheques/:id/edit',
    name: 'salesChequesEdit',
    component: salesChequesForm
  },
  {
    path: 'salesCheques/:id',
    name: 'saleschequesShow',
    component: salesChequesShow
  },

  //purchaseCheques
  {
    path: 'purchaseCheques',
    name: 'purchaseCheques',
    component: purchaseChequesIndex
  },
  {
    path: 'purchaseCheques/create',
    name: 'purchaseChequesCreate',
    component: purchaseChequesForm
  },
  {
    path: 'purchaseCheques/:id/edit',
    name: 'purchaseChequesEdit',
    component: purchaseChequesForm
  },
  {
    path: 'purchaseCheques/:id',
    name: 'purchaseChequesShow',
    component: purchaseChequesShow
  }
]

export default routes
